module.exports = __webpack_public_path__ + "img/jaslogo.878f0b03.png";